var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNbfcicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#64BD71",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0767 35.2606C37.0767 30.9017 28.3589 28.7222 24 28.7222C19.6411 28.7222 10.9232 30.9017 10.9232 35.2606V36.4401C10.9232 36.9923 11.3709 37.4401 11.9232 37.4401H36.0767C36.629 37.4401 37.0767 36.9923 37.0767 36.4401V35.2606ZM24 23.6368C25.7341 23.6368 27.3971 22.948 28.6233 21.7218C29.8495 20.4956 30.5384 18.8325 30.5384 17.0984C30.5384 15.3644 29.8495 13.7013 28.6233 12.4751C27.3971 11.2489 25.7341 10.5601 24 10.5601C22.2659 10.5601 20.6028 11.2489 19.3766 12.4751C18.1505 13.7013 17.4616 15.3644 17.4616 17.0984C17.4616 18.8325 18.1505 20.4956 19.3766 21.7218C20.6028 22.948 22.2659 23.6368 24 23.6368Z",
    fill: "#64BD71"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbfcicon);
export default __webpack_public_path__ + "static/media/nbfcicon.861976ae128cffe4a153c2a14cd08625.svg";
export { ForwardRef as ReactComponent };